module.exports = __webpack_public_path__ + "MDIlogo_notext.png?1cd9d553bb7bc19bad4bd93e7900603c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marathondynamics/MDIlogo_notext.png
// module id = 545
// module chunks = 0